module.exports = __webpack_public_path__ + "media/images/icon-clear-bcab2b653ec489acf36262d55b205d24.svg";